import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Sales from "../views/Sales.vue";
import Shipping from "../views/Shipping.vue";
import Login from "../views/Login.vue";
import { firebaseApp } from "../database/db";
import Toasted from "vue-toasted";

Vue.use(VueRouter);
Vue.use(Toasted);

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/sales",
    name: "Sales",
    component: Sales,
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/shipping",
    name: "Shipping",
    component: Shipping,
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },

  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.authRequired)) {
    if (firebaseApp.auth().currentUser) {
      next();
    } else {
      console.log("auth fail");
      Vue.toasted.show("Not Logged In", {
        type: "error",
        theme: "bubble",
        position: "bottom-center",
        duration: 3000,
      });
      next({
        path: "/login",
      });
    }
  } else {
    next();
  }
});

export default router;
